import { useTranslation } from "react-i18next";
import educationData from "../data/education.json";
import "./Education.css";

const Education = () => {
    const { t } = useTranslation();

    return (
        <main className="Education border-shadow w-50 m-a">
            <h1>{t("education.title")}</h1>
            <section className="qualification">
                <h2>{t("education.qualification.name")}</h2>
                <p><strong>Riveria</strong><br />{t("education.qualification.completed")}</p>
                <p>{t("education.qualification.focus")}</p>
            </section>
            <h2>{t("education.courses")}</h2>
            <ul>
                {educationData.CoursesList.map((course) => (
                    <li key={course.Name}>
                        <a href={course.Link} target="_blank" rel="noopener noreferrer">{t(`education.courseItems.${course.Name}`)}</a>
                    </li>
                ))}
            </ul>
        </main>
    );
};
export default Education;
